import {
  Grid,
} from "@material-ui/core";
import { Sidebar } from "../Sidebar";
import WorkOrderTable from "./WorkOrderTable";

export const WorkOrderPage = () => {
  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <WorkOrderTable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
